import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

function PrivateRoute (){

  const auth = useSelector((state) => state.auth);
  
  // check if user is logged in from store
  return auth.isAuthenticated === true ?  
   <Outlet /> // continue to private route
    : <Navigate to='/login'/> // redirect to login component
};


export default PrivateRoute
